// tippi/src/components/orderer/BillingProfileCard.js
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { isBillingProfileComplete } from '../../utils/billingProfile';
import BillingProfileForm from './BillingProfileForm';
import { COLORS, FONTS } from '../../styles/tokens';

// Bestillerens fakturaopplysninger i profilen. Må være komplette før bestilleren kan opprette oppdrag.
export default function BillingProfileCard() {
  const { userDoc } = useAuth();
  const complete = isBillingProfileComplete(userDoc?.billingProfile);

  return (
    <section style={styles.card} aria-label="Fakturaopplysninger">
      <div style={styles.head}>
        <h3 style={styles.title}>Fakturaopplysninger</h3>
        <span style={{ ...styles.chip, ...(complete ? styles.chipOk : styles.chipMissing) }}>
          {complete ? 'Komplett' : 'Mangler'}
        </span>
      </div>
      <p style={styles.text}>Brukes som mottaker på fakturaene du får.</p>
      <BillingProfileForm />
    </section>
  );
}

const styles = {
  card:       { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 20, padding: 18, marginBottom: 14 },
  head:       { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 },
  title:      { fontFamily: FONTS.display, fontSize: 24, fontWeight: 700, margin: 0, color: COLORS.textDark },
  chip:       { borderRadius: 20, padding: '3px 10px', fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap' },
  chipOk:     { background: COLORS.successBg, color: COLORS.successText },
  chipMissing:{ background: COLORS.warningBg, color: COLORS.warningText },
  text:       { fontSize: 13, color: COLORS.textMid, lineHeight: 1.5, margin: '6px 0 4px' },
};
